module.exports = __webpack_public_path__ + "img/upload-img-icon1.76b0a5ac.svg";